
// Create a trim function.
function trim(input) {
    if (input === undefined) return '';
    if (input === null) return '';
    if ((input.length || 0) == 0) return '';

    var start = 0;
    var end = input.length;

    for (var i = 0; i < input.length; i++) {
        if (input[i] == ' ') start = i + 1;
        else break;
    }

    for (var i = input.length - 1; i > 0; i--) {
        if (input[i] == ' ') end = i;
        else break;
    }

    return input.substr(start, end - start);
}

// Create the namespace for DataCheck functionality.
DataCheck = function () {

    // Create a local context object for manipulating within the data checks.
    this.dataContext = {};
    var self = this;

    // This function will reflect a 'model' object and then update each
    // property with values from the page or 'undefined'.
    // "model" is the empty model for the given data set.
    // "modelDefinition" is the [optional] populated model to copy data from.
    // otherwise controls are the page are used to populate the data.
    function updateModel(model, modelDefinition) {

        if (model.hasOwnProperty('nExDefUID')) {
            try {
                //alert('Ext');

                model['cDisplayName'] = Ext.getCmp("txtDisplayName").getValue();
                model['lVisible'] = Ext.getCmp("chkVisible").checked ? -1 : 0;
                model['cDataType'] = getDataType(Ext.getCmp("cboDisplayType").getValue());
                model['nDataType'] = Ext.getCmp("cboMode").getSelectedIndex();
                model['cMode'] = Ext.getCmp("cboLabType").getValue();
            } catch (exception) {
                //model[prop] = null;
            }
        }
        else {
            for (var prop in model) {
                if (model.hasOwnProperty(prop)) {
                    try {
                        // If we have a model definition
                        if (modelDefinition !== undefined) {
                            // Copy data from that.
                            model[prop] = modelDefinition[prop];
                        } else {
                            // Otherwise, attempt to derive the model information from the page itself.
                            model[prop] = Ext.getCmp(prop).getValue();
                        }
                    } catch (exception) {
                        try {
                            model[prop] = complete_record[prop];        // populate data not found in cmp fields on the page from the record itself (captured on master page)
                        }
                        catch (ex) {
                            model[prop] = null;
                        }
                    }
                }
            }
        }
    }

    function getDataType(dataTypeDisplay) {
        switch (dataTypeDisplay) {
            case ___('NUMERIC'):
                return 1;
            case ___('TEXT'):
                return 2;
            case ___('COMBO'):
                return 3;
            case ___('DATE'):
                return 4;
            //case ___('TIME'):
            //    return 0;
            case ___('CURRENCY'):
                return 6;
            case ___('MEMO'):
                return 7;
            case ___('BOOLEAN'):
                return 8;
            default:
                return 0;  // NONE, TIME, garbage
        }
    }

    function executeDataCheck(dataCheck, modelDefinition) {
        // Standard NULL checking.
        if (dataCheck === undefined) return;
        if (dataCheck.cCode === undefined) return;

        // Get the important parts of the data check.
        var code = dataCheck.cCode;
        var tableName = dataCheck.cFormName;

        // Define a model variable.
        var model = {};

        // Create a state object.
        var state = {
            completed: false,
            passed: false
        };

        // Create some functions that can be called.
        function pass() {
            // And then update the state object.
            state.passed = true;
            state.completed = true;
        }

        function fail() {
            // And then update the state object.
            state.passed = false;
            state.completed = true;
        }

        // This variable determines whether or not we lookup the model schema.
        // The reason being - some "tableNames" are code for something entirely different.
        // So if this is not a real table name, then don't bother with the schema because it will just fail anyway.
        var getModelSchema = tableName !== "Receiving" && tableName !== "Returning" && tableName !== "ToolAssignments" && tableName !== "BatchChange" && tableName !== "BatchProcess";

        // Ajax the model information for our given class.
        if (getModelSchema) {
            $.ajax({
                type: 'post',
                url: '/DataCheck/GetModelSchema',
                data: {
                    __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
                    model: tableName
                },
                dataType: 'json',
                async: false,
                success: function (result) {
                    // First, check if this is a failure.
                    if (result.success !== undefined) {
                        if (result.success === false) {
                            // Then there was a problem... so stop processing the model information.
                            return;
                        }
                    }
                    // Otherwise, we theoretically have a model.
                    model = result;

                    // Update the model.
                    updateModel(model, modelDefinition);
                }
            });
        } else {
            model = modelDefinition;
        }

        var appVer = null;
        $.ajax({
            type: 'post',
            url: '/DataCheck/GetAppVersion',
            data: {
                __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            },  
            dataType: 'json',
            async: false,
            success: function (result) {
                appVer = result;
            }
        });


        // The following code attempts to resolve the (typically) global 
        // 'recordID' variable, when using our one-off pages.
        // NOTE: window["recordID"] is synonymous with a global variable being called
        // recordID because the window namespace is far enough out of scope to propogate
        // downwards.
        try {
            // try to setup a recordID if we are on a special table.
            switch (tableName) {
                case "Receiving":
                    window["recordID"] = model.nAssetUID;
                    break;
                case "Returning":
                    window["recordID"] = model.nAssetUID;
                    break;
                case "ToolAssignments":
                    window["recordID"] = model.nAssetUID;
                    break;
                case "BatchProcess":
                    window["recordID"] = model;
                    break;
                case "BatchChange":
                    window["recordID"] = model.nCallSheetUID;
                    break;
            }
        } catch (exception) { }

        // Try to execute the data check.
        try {
            // Inject the model.
            var Model = model;
            var appVersion = appVer;

            // debug
            //alert(Object.keys(model));
            //alert(Object.values(model));
            //alert(dataCheck.nValidationUID);

            // Inject the state object.
            var Context = self.dataContext;
            // Create an object state.
            var objState = {
                primaryKey: '4CA22A04-0079-4033-84A5-E5968C7F3F17',
                nValidationUID: dataCheck.nValidationUID
            };

            try {
                // Try to get the recordID from the global variable
                objState.primaryKey = recordID;
            } catch (exception) { }

            // Note: the javascript string replace function only replaces 1 instance of the thing, so we use regex 'g' to do a global replace
            // Inject a state object parameter for sql calls
            code = code.replace(/DataCheck.ExecuteSQL\(/g, "DataCheck.ExecuteSQL(objState, ");
            code = code.replace(/DataCheck.ExecuteSQLParams\(/g, "DataCheck.ExecuteSQLParams(objState, ");
            code = code.replace(/DataCheck.UpdateRecipients\(/g, "DataCheck.UpdateRecipients(objState, ");

            // debug
            //alert(code);

            // Execute the code until the state object has a value.
            var safeEval = Function("pass", "fail", "Context", "Model", "objState", "appVersion", "state", "recordID", code);
            safeEval(pass, fail, Context, Model, objState, appVersion, state, recordID);
        } catch (exception) {
            // But alert the user.
            Ext.Msg.alert(exception, ___("THERE_WAS_A_PROBLEM_WITH_ONE_OF_THE_DATACHECKS_ASSOCIATED_WITH_THIS_PAGE") + " <br />" + ___("PLEASE_CONTACT_A_SYSTEM_ADMINISTRATOR"), function () {
                // If something went wrong, skip the data check.
                pass();
            });
        }

        // debug
        //alert(Object.keys(state));
        //alert(Object.values(state));

        // Return a reference to the state object for later consumption.
        return state;
    }

    // Create a private method for getting all associated data checks
    // attached to a model.
    this.Execute = function (modelName, callback, modelDefinition) {

        // Execute a jQuery AJAX call to get the associated data checks.
        $.ajax({
            type: 'post',
            url: '/DataCheck/GetDataChecks',
            dataType: 'json',
            data: {
                model: modelName
            },
            success: function (response) {
                // Some simple null checking.
                if (response === undefined)
                    // If we didn't receive a response, something went wrong.
                    // NOTE*** We should probably log and send a message to the user.
                    return;

                if (response.length == 0) {
                    // If the response is an empty array, then just invoke the callback
                    // because there are no data checks to run.
                    callback(true);
                    // And then return so we don't process an empty array.
                    return;
                }

                // Create a variable for tracking which data check we are on.
                var dataCheckIndex = 0;

                // This variable will be used to track the last known state object.
                var currentState = undefined;

                // Create a function for processing the next datacheck
                function processNext() {
                    // Grab the [n]th data check.
                    var dataCheck = response[dataCheckIndex++];
                    // Process it and set the state object.

                    currentState = executeDataCheck(dataCheck, modelDefinition);
                    // Return the current state object
                    return currentState;
                }

                // Process our first data check.
                processNext();

                function timer() {
                    // Set a timer to wait for the completion state.
                    setTimeout(function () {
                        // If the current state is completed, process the next.
                        if (currentState.completed) {
                            // If the current state is a "pass"...
                            if (currentState.passed) {
                                // Process the next one, if applicable.
                                // If there are no more to process...
                                if (processNext() === undefined) {
                                    // Invoke the callback and report success.
                                    callback(true);
                                } else {
                                    // Otherwise, process any additional ones.
                                    timer();
                                }
                            } else {
                                // Invoke the callback and report a failure.
                                callback(false);
                            }
                        } else {
                            // Otherwise, trigger the timer again.
                            timer();
                        }
                    }, 200);
                }

                // Invoke the timer once.
                timer();
            }
        });
    }
};


// "static" function that doesn't require a DataCheck object
// get the model from the table name (stored in cFormName)
DataCheck.getModelPropsForEditor = function (tableName) {

    // Undefined, NULL , "" 
    if (!tableName)
        return;

    // substitute for one-offs
    var lowerName = tableName.toLowerCase();
    if (lowerName === "batchchange" || lowerName === "batchprocess" || lowerName === "receiving" || lowerName === "returning")
        tableName = 'CallSheets';

    var model = {};

    // Ajax the model information for our given class.
    $.ajax({
        type: 'post',
        url: '/DataCheck/GetModelSchema',
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            model: tableName
        },
        dataType: 'json',
        async: false,
        success: function (result) {
            if (result.success !== undefined) {
                if (result.success === false) 
                    return;  // exit on failure
            }
            
            model = result;  // otherwise, we theoretically have a model.
        }
    });

    return model;
}

// "static" function that doesn't require a DataCheck object
DataCheck.getTableColumnsForEditor = function (id) {

    if (id === undefined)
        return;

    var data = {};
    var token = getWindowAntiForgeryTokenValue();
    if (token === null || token === undefined)
        token = getSiteAntiForgeryTokenValue();

    $.ajax({
        type: 'post',
        url: '/DataCheck/GetTableColumns',
        data: {
            __RequestVerificationToken: token,
            tableId: id
        },
        dataType: 'json',
        async: false,
        success: function (result) {
            if (result.success !== undefined) {
                if (result.success === false) {
                    return;
                }
            }

            // debug
            //alert(result[0]);
            data = result;
        }
    });

    return data;
}

// This function is kind of like a static execute method.
DataCheck.Execute = function (model, modelDefinition, callback) {
    var dc = new DataCheck();
    dc.Execute(model, callback, modelDefinition);
}

// NOTE: This is a private function,
// it should be delegated somewhere else instead of as a public
// exposed method. Please fix this sometime...
DataCheck.ExecuteBatchSync = function (recordset, tableName, callback, count, dc) {

    if (count <= 0) {
        callback({
            pass: true,
            row: 0
        });
        return;
    }
    var item = recordset[count - 1];
    dc.Execute(tableName, function (pass) {
        if (pass)
            DataCheck.ExecuteBatchSync(recordset, tableName, callback, count - 1, dc);
        else
            callback({
                pass: false,
                row: count - 1
            });
    }, item);
}

// This is a "batch" execute method which is useful for grid pages like
// receiving and returning.
DataCheck.ExecuteBatch = function (recordset, tableName, callback) {

    // Create the base datacheck object (note, all calls within
    // a datacheck object share a "context object" which is why we
    // need to pass this in to the function. )
    var dc = new DataCheck();
    DataCheck.ExecuteBatchSync(recordset, tableName, callback, recordset.length, dc);

}

// Define functions that can be used by the data checks.
DataCheck.Prompt = function (title, message, action) {
    Ext.Msg.prompt(title, message, action);
};

// This function pops up an alert box.
DataCheck.Alert = function (title, message, action) {
    Ext.Msg.alert(title, message.replace(/(\n)/g, '<br />'), action); // display in new line when \n is given.
}

// This function questions the user with a yes or no dialog.
DataCheck.Confirm = function (title, message, action) {
    Ext.Msg.confirm(title, message, action);
}

// This function will "red-squiggly" something.
DataCheck.AddValidation = function (control, message) {
    Ext.getCmp(control).markInvalid(message);
}

// This function will set the value of a control on the page.
DataCheck.SetValue = function (control, value) {
    Ext.getCmp(control).setValue(value);
}

// This function will get the value of a control on the page.
DataCheck.GetValue = function (control) {
    return Ext.getCmp(control).getValue();
}

// A simple helper function for safe nulling strings.
DataCheck.SafeNull = function (input) {
    if (input === undefined || input === null) {
        return "";
    } else {
        return input;
    }
}

// A simple helper function for getting the label text for a edit/dropdown 
// type field (text field) or a checkbox type field (boxLabel field) 
DataCheck.GetName = function (fieldName) {
    
    if (fieldName === undefined || fieldName === null)
        return "";

    if (fieldName.startsWith('l')) {
        var checkbox = Ext.getCmp(fieldName);
        if (checkbox !== undefined && checkbox !== null)
            return checkbox.boxLabel;
    }
    else {
        var label = Ext.getCmp('lbl_' + fieldName);
        if (label !== undefined && label !== null)
            return label.text;
    }

    return fieldName;
}

DataCheck.GetExRow = function (property) {
    var grid = Ext.getCmp('ToolAssignmentEx');
    var isToolAssignment = !!grid;
    var isTaAddMode = false;
    var isReceivingDialog = false;

    if (isToolAssignment) 
        isTaAddMode = grid.isAddMode === true;

    if (!grid) {
        grid = Ext.getCmp('CallsheetEx');  // CallsheetEx is the Receiving dialog Call Sheet Extended Data
        isReceivingDialog = !!grid;  // we are in the Receiving dialog if the grid is defined
    }

    if (!grid)
        grid = Ext.getCmp('grdExtendedData') || Ext.getCmp('assetEXData');

    if (!grid)
        return null;

    //Handle Receiving or ToolAssignmentEx case (non add-Mode only, since in AddMode for Tool Assignment all extended data is the same for all assets)
    if (isReceivingDialog || (isToolAssignment && !isTaAddMode)) {

        var mainGrid;

        if (isReceivingDialog)
            mainGrid = Ext.getCmp('assetGrid');
        else
            mainGrid = Ext.getCmp('fillGrdAssignments');

        if (!mainGrid)  // Didn't find the Tool Assignment grid Or the Receving Dialog asset grid!
            return null;

        var mainStore = mainGrid.getStore();
        var index = mainStore.find('nAssetUID', window["recordID"]);
        if (index < 0)
            return null;

        var rec = mainStore.getAt(index);

        if (!rec || !rec.exData)
            return null;
        
        if (rec.exData && Array.isArray(rec.exData.rows)) {           // ToolAssignment: rec.exData.rows is an array of row objects
            for (var i = 0; i < rec.exData.rows.length; i++) {
                if (rec.exData.rows[i].field === property)
                    return rec.exData.rows[i];
            }
        }
        else if (Array.isArray(rec.exData)) {                        // Receiving: rec.exData is an array of objects
            for (var i = 0; i < rec.exData.length; i++) {
                if (rec.exData[i].data && rec.exData[i].data.field === property)
                    return rec.exData[i];
            }
        }

        return null;
    }

    var store = grid.getStore();

    // Handle all other grids
    for (var i = 0; i < store.getCount(); i++) {
        var item = store.getAt(i);
        if (item.get("field") === property)
            return item;
    }

    return null;
};

DataCheck.GetExField = function (property, fieldName) {
    if (property == null || fieldName == null)
        return null;

    var row = DataCheck.GetExRow(property);
    if (!row)
        return null;

    return (typeof row.get === 'function') ? row.get(fieldName) : row[fieldName];
};

DataCheck.GetExValue = function (property) {
    return DataCheck.GetExField(property, 'value');
};

DataCheck.GetExName = function (property) {
    return DataCheck.GetExField(property, 'text');
};


DataCheck.SetExValue = function (property, value) {
    var grid = Ext.getCmp('grdExtendedData') || Ext.getCmp('CallsheetEx') || Ext.getCmp('ToolAssignmentEx') || Ext.getCmp('assetEXData'); //Note: CallsheetEx is the Receiving dialog Call Sheet Extended Data
    if (grid === undefined)
        return "";

    var store = grid.getStore();
    if (store === null)
        return;

    var i = store.find("field", property);
    if (i > -1) {
        row = store.getAt(i);
        row.data.value = value;
    }
};

DataCheck.IsExEnabled = function () {
    var grid = Ext.getCmp('grdExtendedData') || Ext.getCmp('CallsheetEx') || Ext.getCmp('ToolAssignmentEx') || Ext.getCmp('assetEXData');  //Note: CallsheetEx is the Receiving dialog Call Sheet Extended Data
    if (grid === undefined) return false;

    var disabled = false;
    grid.bubble(function () {
        if (this.disabled) {
            disabled = true;
        }
    });
    return !disabled;
}

function IsApplicationModuleType(applicationType) {
    var isAppModuleType = false;
    $.ajax({
        type: 'post',
        url: '/DataCheck/GetAppModuleType',
        dataType: 'json',
        async: false,
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            appModuleType: applicationType 
        },
        success: function (result) {
            isAppModuleType = result;
        }
    });

    return isAppModuleType;
}

DataCheck.IsCustomerPortal = function () {
    return IsApplicationModuleType(4); // 4 ~ Customer Portal
}

DataCheck.IsMetteam = function () {
    return IsApplicationModuleType(0); // 0 ~ MET/TEAM
}

DataCheck.IsMetteamMobile = function () {
    return IsApplicationModuleType(3); // 3 ~ MET/TEAM Mobile
}

DataCheck.UpdateRecipients = function (state, fnName, callback) {
    if (state === undefined) return;
    if (fnName === undefined) return;

    // Invoke the SQL Function
    $.ajax({
        type: 'POST',
        url: '/DataCheck/UpdateRecipients',
        dataType: 'json',
        data: {
            cFunctionName: fnName,
            uid: state.primaryKey
        },
        success: function (result) {
            // Execute the callback if we have one.
            if (callback !== undefined)
                callback(result);
        }
    });
};

DataCheck.BatchProcessSetCopy = function (field, value) {
    if (field === undefined) return;
    if (value === undefined) return;
    if (!(value === 0 || value === 1)) return;

    var fields = Ext.getCmp('callsheetFieldGrid');
    if (fields === undefined) return;

    var fieldStore = fields.getStore();
    if (fieldStore === undefined) return;

    switch (field) {
        case 'lCopyLogNotes':
            Ext.getCmp('lCopyLogNotes').setValue(value != 0);
            return;
        case 'lCopyLabor':
            Ext.getCmp('lCopyLabor').setValue(value != 0);
            return;
        case 'lCopyStandards':
            Ext.getCmp('lCopyStandards').setValue(value != 0);
            return;
        case 'lCopyAccreditations':
            Ext.getCmp('lCopyAccreditations').setValue(value != 0);
            return;
        case 'lAddMasterLogNotes':
            Ext.getCmp('lAddMasterLogNotes').setValue(value != 0);
            return;
        case 'lAddChildLogNotes':
            Ext.getCmp('lAddChildLogNotes').setValue(value != 0);
            return;
    }

    fieldStore.each(function (item) {
        var f = item.get('cField');
        if (f === field) {
            item.set('lCopy', value);
            return;
        }
    });
};

DataCheck.BatchProcessGetCopy = function (field) {
    if (field === undefined) return 0;

    var fields = Ext.getCmp('callsheetFieldGrid');
    if (fields === undefined) return 0;

    var fieldStore = fields.getStore();
    if (fieldStore === undefined) return 0;

    switch (field) {
        case 'lCopyLogNotes':
            return Ext.getCmp('lCopyLogNotes').getValue() ? 1 : 0;
        case 'lCopyLabor':
            return Ext.getCmp('lCopyLabor').getValue() ? 1 : 0;
        case 'lCopyStandards':
            return Ext.getCmp('lCopyStandards').getValue() ? 1 : 0;
        case 'lCopyAccreditations':
            return Ext.getCmp('lCopyAccreditations').getValue() ? 1 : 0;
        case 'lAddMasterLogNotes':
            return Ext.getCmp('lAddMasterLogNotes').getValue() ? 1 : 0;
        case 'lAddChildLogNotes':
            return Ext.getCmp('lAddChildLogNotes').getValue() ? 1 : 0;
    }

    var idx = fieldStore.find("cField", field);
    if (idx > -1) {
        var record = fieldStore.getAt(idx);
        return record.get('lCopy');
    }
}

DataCheck.BatchProcessGetMasterUID = function () {
    return Ext.getCmp('nMasterUID').getValue();
}

DataCheck.BatchProcessGetCallSheetUIDs = function () {
    return Ext.getCmp('callSheetUIDS').getValue();
}

// NOTE: State is automatically 'injected'. When using this function
// in a data check, you should pass parameters as though the signature were
// function (fnName, callback)
DataCheck.ExecuteSQL = function (state, fnName, callback) {
    if (state === undefined) return;
    if (fnName === undefined) return;

    // debug
    //alert('DataCheck.ExecuteSQL');
    //alert(state);
    //alert(state.nValidationUID)

    // Invoke the SQL Function
    $.ajax({
        type: 'POST',
        url: '/DataCheck/ExecuteSQL',
        dataType: 'json',
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            nValidationUID: state.nValidationUID,
            cFunctionName: fnName,
            uid: state.primaryKey
        },
        success: function (result) {
            // Execute the callback if we have one.
            if (callback !== undefined)
                callback(result);
        }
    });
}

// NOTE: State is automatically 'injected'. When using this function
// in a data check, you should pass parameters as though the signature were
// function (fnName, parameters, callback)
DataCheck.ExecuteSQLParams = function (state, fnName, parameters, callback) {
    if (state === undefined) return;
    if (fnName === undefined) return;
    if (parameters === undefined) return;

    // debug
    //alert('DataCheck.ExecuteSQLParams');
    //alert(state);
    //alert(state.nValidationUID)
    //alert(parameters)

    // Invoke the SQL Function
    $.ajax({
        type: 'POST',
        url: '/DataCheck/ExecuteSQLParams',
        dataType: 'json',
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            nValidationUID: state.nValidationUID,
            cFunctionName: fnName,
            parameters: parameters,
            uid: state.primaryKey
        },
        success: function (result) {
            // Execute the callback if we have one.
            if (callback !== undefined)
                callback(result);
        }
    });
}

DataCheck.Debug = function (message, obj) {
    if (message === undefined) return;

    $.ajax({
        type: 'POST',
        url: '/DataCheck/Debug',
        dataType: 'json',
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            message: message,
            obj: obj
        }
    });
}

DataCheck.RemoveUTCOffset = function (date) {
    if (date === undefined) return null;

    // debug
    //alert('DataCheck.RemoveUTCOffset');
    //alert(date);

    var dt = null;

    $.ajax({
        type: 'POST',
        url: '/DataCheck/RemoveUTCOffset',
        dataType: 'json',
        async: false,
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
            date: date
        },
        success: function (result) {
            if (result.success !== undefined) {
                if (result.success === false) {
                    return;
                }
            }

            dt =  result.message;
        }
    });

    return dt;
}

DataCheck.ToolAssignmentMode = function () {

    var grid = Ext.getCmp('fillGrdAssets'); // found on AddMode.aspx (used for Check Out)
    if (grid != undefined)
        return 0; // Check Out mode

    grid = Ext.getCmp('fillGrdAssignments'); // found on Manage.aspx (used for Edit/Check In)
    if (grid != undefined) {
        var retDate = Ext.getCmp('tReturnDate');
        if (retDate != undefined) {
            // if the Return Date has no value, assume the user is editing the record; otherwise, assume it's a Check In
            if (retDate.getValue() === null || retDate.getValue() === '')
                return 1;   // Edit mode

            return 2;   // Check In mode
        }
    }
    return -1;  // Not applicable (not a Tool Assignment Data Check)
}
